import React, { useState, useEffect, useCallback } from "react";
import { useLoading } from "../../../../context/LoadingContext";
import DataTable from "../../../Requirement/components/common/ReusableTable";
import {
  fetchData,
  searchfetchQueries,
  postQuery,
} from "../../../Requirement/services/RequirementServices";
import dayjs from "dayjs";
import SearchFilter from "../../../Requirement/components/common/SearchFilter";
import OfferDetails from "../../requirement/component/OfferDetails";
import AlertModal from "../../../Requirement/components/common/AlerModel";
import TrustScoreModal from "../../../../components/common/TrustScoreModal";
import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { getParameterFromManager } from "../../../../services/Utils";
const ProductOffers = ({ product }) => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [activeUser, setActiveUser] = useState("");
  const [userKybInfo, setUserKybInfo] = useState(null);
  const [isKybValid, setIsKybValid] = useState(true);
  const [isKybLoading, setIsKybLoading] = useState(true);
  const [offerList, setOfferList] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [productList, setProductList] = useState([]);
  const [productGradeList, setProductGradeList] = useState([]);
  const [rowStart, setRowStart] = useState(0);
  const [pageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [productDetails, setProductDetails] = useState({});
  const [INRToUsd] = useState(0.012);
  const [searchValues, setSearchValues] = useState({
    searchOfferProduct: "",
    searchOfferProductGrade: "",
    searchPriceRange: "",
  });

  // console.log('selectedProduct!!!',product);

  const priceOptions = [
    { value: "", label: "Select Range" },
    { value: "0-1000", label: "0-1000 USD" },
    { value: "1000-2000", label: "1000-2000 USD" },
    { value: "2000-5000", label: "2000-5000 USD" },
    { value: "Above-5000", label: "Above 5000 USD" },
  ];

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };
  // State for Verification Status Modal
  const [trustModal, setTrustModal] = useState(false);

  const trustModel = useCallback(() => {
    setTrustModal(true);
  }, []);
  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_BUYERS")) {
          await Auth.signOut();
          navigate("/login/buyer");
        } else {
          setActiveUser(user.attributes.email);

        }
      } catch (error) {
        console.error("Error checking user:", error);
        await Auth.signOut();
        navigate("/login/buyer");
      }
    };
    checkUser();
  }, [navigate]);
  useEffect(() => {
    const checkUserKYB = async () => {
      if (!activeUser) return; // Wait until activeUser is available
      setLoading(true);

      try {
        const userKYBResponse = await fetchData({
          target: "listUserKYB",
          userOrder: "UserKybID",
          orderDirection: "ASC",
          rowStart: 0,
          pageSize: 1,
          filterTerms: { EmailID: activeUser },
        });

        console.log("userKYBResponse", userKYBResponse.items);

        if (userKYBResponse.items && userKYBResponse.items.length > 0) {
          const kybInfo = userKYBResponse.items[0];
          // Check if Status is "" or "Pending"
          if (kybInfo.Status === "" || kybInfo.Status === "Pending") {
            setUserKybInfo(null); // Set to null if Status is empty or Pending
            setIsKybValid(false); // Set isKybValid to false
            console.log(kybInfo.Status)
          } else {
            setUserKybInfo(kybInfo); // Set the KYB info if Status is neither
            setIsKybValid(true); // Set isKybValid to true
          }
        } else {
          setUserKybInfo(null); // No items found, set to null
          setIsKybValid(false); // No valid KYB info
        }
      } catch (error) {
        console.error("Error fetching KYB info:", error);
        setUserKybInfo(null);
        setIsKybValid(false); // Error case, assume invalid
      } finally {
        setLoading(false);
      }
    };

    checkUserKYB();
  }, [activeUser, setLoading]);
  const loadProductList = useCallback(async () => {
    try {
      const [initialResponse] = await Promise.all([
        fetchData({
          target: "listProducts",
          userOrder: "ProductName",
          rowStart: 0,
          pageSize: 1,
          filterTerms: { Status: "ACTIVE" },
        }),
      ]);

      const totalCount = initialResponse?.total || initialResponse?.length || 0;

      if (totalCount > 0) {
        const [allProducts] = await Promise.all([
          searchfetchQueries({
            target: "listProducts",
            userOrder: "ProductName",
            rowStart: 0,
            pageSize: totalCount,
            filterTerms: { Status: "ACTIVE" },
          }),
        ]);

        const distinctProducts = Array.from(
          new Map(allProducts.map((p) => [p.ProductName, p])).values()
        );
        setProductList(distinctProducts);
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("Error loading products: ", error);
    }
  }, []);

  const loadProductGrades = useCallback(async (productName) => {
    try {
      const [allGrades] = await Promise.all([
        fetchData({
          target: "listProducts",
          userOrder: "ProductName",
          rowStart: 0,
          pageSize: 500,
          filterTerms: { ProductName: productName },
        }),
      ]);
      if (allGrades.items.length > 0) {
        setProductGradeList(allGrades.items);
      } else {
        setProductGradeList([]);
      }
    } catch (error) {
      console.error("Error loading product grades: ", error);
    }
  }, []);

  const getProductDetails = useCallback(async (productId) => {
    try {
      const response = await fetchData({
        target: "listProducts",
        userOrder: "ProductID",
        rowStart: 0,
        pageSize: 1,
        filterTerms: { ProductID: productId },
      });

      if (response.items && response.items.length > 0) {
        const product = response.items[0];
        setProductDetails({
          ProductName: product.ProductName,
          Grade: product.Grade,
        });
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
      setProductDetails({});
    }
  }, []);

  const formatPrice = useCallback((price) => {
    if (!price || price === "") return "0.00";
    const numPrice = parseFloat(price);
    return isNaN(numPrice) ? "0.00" : numPrice.toFixed(2);
  }, []);

  const formatDate = useCallback((dateString) => {
    if (!dateString) return "";
    try {
      return dayjs(dateString).format("DD-MM-YYYY");
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  }, []);

  const loadDetailbyProductname = useCallback(
    async (searchValues, newRowStart = rowStart) => {
      setLoading(true);
      try {
        const body = {
          target: "listBuyerItemDetails",
          userOrder: "CreatedAt DESC",
          rowStart: newRowStart,
          pageSize: pageSize,
          filterTerms: {
            GPOOfferStatus: "Indicative",
            ProductID: product.ProductID || undefined,
          },
        };
        const response = await fetchData(body);
        console.log(response, "setOfferList");
        const modifiedItems = (response.items || response).map((item) => ({
          ...item,
          id: item.GPOfferID, // Add id property with value from RequirementsID
        }));
        setOfferList(modifiedItems);
        setTotalItems(response.total || 0);
      } catch (error) {
        console.error("Error loading clients: ", error);
        setOfferList([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    [pageSize, rowStart, setLoading]
  );

  const handleSearch = (searchValues) => {
    setRowStart(0);
    // loadDetailbyProductname(searchValues, 0);
  };

  const handlePageChange = (page) => {
    const newRowStart = (page - 1) * pageSize;
    setRowStart(newRowStart);
    // loadDetailbyProductname(searchValues, newRowStart);
  };

  const handleRowClick = (row, event) => {
    console.log("Offer row clicked:", row);
    // console.log("Row structure:", Object.keys(row));

    setSelectedOffer(row);
  };

  // const handleOfferResponse = () => {
  //   console.log("Offer response handled");
  //   setSelectedOffer(null);
  //   onResponse();
  // };

  const Button = ({ label, onClick }) => {
    return (
      <button
        className="btn-action-re"
        onClick={onClick}
        style={{ width: "140px" }}
      >
        {label}
      </button>
    );
  };

  // const sendTrueToParent = () => {
  //   console.log("child sendTrueParent");
  //   onResponse(true); // Sends true to parent via callback
  // };

  const currentPage = Math.floor(rowStart / pageSize) + 1;

  const fields = [
    {
      name: "searchOfferProduct",
      label: "Product",
      type: "dropdown",
      options: productList.map((item) => ({
        value: item.ProductName,
        label: item.ProductName,
      })),
      value: searchValues.searchOfferProduct,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchOfferProduct: value }));
        loadProductGrades(value);
      },
    },
    {
      name: "searchOfferProductGrade",
      label: "Product Grade",
      type: "dropdown",
      options: productGradeList.map((item) => ({
        value: item.Grade,
        label: item.Grade,
      })),
      value: searchValues.searchOfferProductGrade,
      onChange: (value) => {
        setSearchValues((prev) => ({
          ...prev,
          searchOfferProductGrade: value,
        }));
      },
    },
    {
      name: "searchPriceRange",
      label: "Price Range (USD)",
      type: "dropdown",
      options: priceOptions,
      value: searchValues.searchPriceRange,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchPriceRange: value }));
        // fetchMatchingOffers({ ...searchValues, searchPriceRange: value }, 0);
      },
    },
  ];

  const columns = [
    { id: "OfferNumber", numeric: false, label: "Offer No" },
    { id: "ProductName", numeric: false, label: "Product" },
    { id: "Grade", numeric: false, label: "Grade" },
    {
      id: "Quantity",
      numeric: true,
      label: "Quantity (MT)",
      renderCell: (row) => formatPrice(row.Quantity),
    },
    {
      id: "FOBSalePrice",
      numeric: true,
      label: "FOB Sale Price (USD)",
      renderCell: (row) => row.FOBSalePrice,
    },
    { id: "Country", numeric: false, label: "Origin Country" },
    { id: "DestinationCountry", numeric: false, label: "Destination" },
    { id: "INCO", numeric: false, label: "INCO Terms" },
    { id: "OfferType", numeric: false, label: "Offer Type" },
    // { id: "OfferStatus", numeric: false, label: "Offer Status", renderCell: (row) => row.OfferStatus||"Indicative",},
    {
      id: "GPOOfferStatus",
      numeric: false,
      label: "Offer Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.GPOOfferStatus) {
          case "BAFO":
            bgColor = "#e0f2fe";
            textColor = "#0369a1";
            break;
          case "Firmoffer":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
            row.GPOOfferStatus = "Indicative"; // Set default status
            break;
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
            }}
          >
            {row.GPOOfferStatus}
          </span>
        );
      },
    },
    {
      id: "CreatedAt",
      numeric: false,
      label: "Created Date",
      renderCell: (row) => formatDate(row.CreatedAt),
    },
    {
      id: "Expires",
      numeric: false,
      label: "Expires",
      renderCell: (row) => formatDate(row.Expires),
    },
    {
      id: "KYBStatus",
      numeric: false,
      label: "Seller Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.KYBStatus) {
          case "Approved":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
              display: "inline-block",
            }}
          >
            {row.KYBStatus === "Approved" ? "Verified" : "Unverified"}
          </span>
        );
      },
    },
  ];

  // useEffect(() => {
  //   if (requirementDetails) {
  //     getProductDetails(requirementDetails.ProductID);
  //     loadProductList();
  //   }
  // }, [requirementDetails, getProductDetails, loadProductList]);

  useEffect(() => {
    loadDetailbyProductname(searchValues);
  }, [rowStart, pageSize, loadDetailbyProductname, searchValues]);

  return (
    <div>
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="search-filter">
        <div className="title4">
          <div className="head-text">Product Offers</div>
        </div>
        {/* <div className="filter4">
          <SearchFilter fields={fields} onSearch={handleSearch} />
        </div> */}
      </div>

      <DataTable
        columns={columns}
        data={offerList}
        total={totalItems}
        title="Product Offers"
        rowsPerPage={pageSize}
        onPageChange={handlePageChange}
        currentPage={currentPage}
        onRowClick={handleRowClick}
        selectedRows={
          selectedOffer ? [selectedOffer.GPOfferID || selectedOffer.id] : []
        }
      />
      {selectedOffer && (
        <div className="offer-detail1">
          <div className="header-text-re">
            <div className="head-text">Offer Details</div>
            <div className="button-group">
              <Button label="Verification Status" onClick={trustModel} />
            </div>
          </div>

          <OfferDetails
            offer={selectedOffer}
            btnShortlist={false}
            btnSendQuery={false}
            btnRequestQuote={false}
            btnRequestSpecifications={false}
            btnRequestBestPrice={false}
            btnNegotiate={false}
            btnRequestShippingDetails={false}
            btnLogisticsSupport={false}
            INRToUsd={INRToUsd}
            breakupTab={true}
            IsKybValid={isKybValid}
          // activeUser={activeUser}
          // requirementDetails={requirementDetails}
          // onResponse={handleOfferResponse}
          />
        </div>
      )}
      {/* Verification Status Modal */}
      {trustModal && selectedOffer && (
        <TrustScoreModal
          onClose={() => setTrustModal(false)}
          userEmail={selectedOffer.SellerEmailID}
        />
      )}
    </div>
  );
};

export default ProductOffers;
